import request from "@/utils/request";

export function getMake() {
  return request({
    url: "/finder/common/makes",
    method: "get"
  });
}

export function getModel() {
  return request({
    url: "/finder/common/models",
    method: "get"
  });
}

export function search(params) {
  return request({
    url: "finder/external/products/search",
    method: "get",
    params: params
  });
}

export function conditionSearch(params) {
  return request({
    url: "finder/external/conditions",
    method: "get",
    params: params
  });
}

export function productsClick(params) {
  return request({
    url: "finder/external/products/click",
    method: "post",
    data: params
  });
}
export function getSearchInfo(params) {
  return request({
    url: "/finder/search",
    method: "get",
    params: params
  });
}

